import {
  FilteredOutEntities,
  type SelectionState,
  updateFilteredOutEntities,
} from "@/pages/human-resources/time-management/components/display-filters/model/FilteredOutEntities.ts";
import { type Draft, immerable } from "immer";
import type { ScheduleViewArrangement } from "@/pages/human-resources/time-management/model/ScheduleViewArrangement.ts";
import { ScheduleEmployeesOrder } from "@/pages/human-resources/time-management/model/ScheduleEmployeesOrder.ts";

export class ScheduleViewFilters {
  [immerable] = true;
  public constructor(
    public readonly filteredOutEntities = new FilteredOutEntities(),
    public readonly viewArrangement: ScheduleViewArrangement = "section",
    public readonly employeesOrder: ScheduleEmployeesOrder = new ScheduleEmployeesOrder(
      "role",
    ),
  ) {}
}

export type ScheduleViewFiltersAction =
  | { type: "initFilters"; filteredOutEntities: FilteredOutEntities }
  | { type: "setFilteredOutEntities"; filterState: SelectionState }
  | { type: "setViewArrangement"; viewArrangement: ScheduleViewArrangement }
  | { type: "setEmployeesOrder"; order: ScheduleEmployeesOrder };

export function reducer(
  draft: Draft<ScheduleViewFilters>,
  action: ScheduleViewFiltersAction,
): void {
  switch (action.type) {
    case "initFilters": {
      draft.filteredOutEntities = action.filteredOutEntities;
      break;
    }
    case "setFilteredOutEntities": {
      updateFilteredOutEntities(draft.filteredOutEntities, action.filterState);
      break;
    }
    case "setViewArrangement": {
      draft.viewArrangement = action.viewArrangement;
      if (
        action.viewArrangement === "role" &&
        draft.employeesOrder.order === "role"
      ) {
        draft.employeesOrder = new ScheduleEmployeesOrder("name");
      }
      break;
    }
    case "setEmployeesOrder": {
      draft.employeesOrder = action.order;
      break;
    }
  }
}
